import { Button } from 'component/Button'
import { Input } from 'component/Input'
import { Typo } from 'component/Typo'
import { Vertical } from 'component/Vertical'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { Icon } from 'icon/Icon'
import { observer } from 'mobx-react-lite'
import { employeeModal } from 'page/catalog/employee/EmployeeModal/EmployeeModalStore'
import { Employee } from 'page/catalog/employee/EmployeeModal/step/Employee'
import { employee } from 'page/catalog/employee/store/EmployeeStore'

export const ChangeStep = observer(() => {
  const { employees, search } = employee
  const store = employeeModal.it

  const onLogin = useLatestCallback(async () => {
    store.step = 'login'
  })

  const onChange = useLatestCallback((value: string) => {
    employee.search = value
  })

  return <Vertical gap={16}>
    <Input value={search} onChange={onChange} left={<Icon size={16} name="search" />} />
    {employees.map(it => (
      <Employee key={it.user.user_id} data={it} />
    ))}
    <Button large action={onLogin} primary>
      <Typo size={11} upper>
        {i18n('Login')}
      </Typo>
    </Button>
  </Vertical>
})
